export default "__VITE_ASSET__BGqb3jUc__"